/** VIP 功能 */
export enum FuncListType {
    /** 智能消除 */
    aieraser = 'aieraser',
    /** 画质修复 */
    restoration = 'restoration',
    /** 多重高级画笔 */
    brush = 'brush',
    /** 无损改尺寸 */
    losslessResizing = 'losslessResizing',
    /** 标注笔功能 */
    markup = 'markup',

    puzzle = 'puzzle',
}

export enum MaterialIdsType {
    /** 背景素材 */
    BACKGROUND = 'background-material',
    /** 滤镜素材 */
    FILTER = 'filter-material',
    /** mask素材 */
    MASK = 'mask-material',
    /** 图片素材 */
    IMAGE_MATERIAL = 'img-material',
    /** 照片素材 */
    PHOTO_MATERIAL = 'photo-material',
    /** 文字素材 */
    TEXT_MATERIAL = 'text-material',
    /** 字体 */
    FONT_FAMILY = 'font-family',
    /** 图片效果特效 */
    IMAGE_EFFECT = 'imageEffect-material',
    /** 水印素材 */
    WATERMARK = 'watermark-material',
    /** 文字高级特效 */
    TEXT_EFFECT = 'text-effect',
    /** 新版花字素材 */
    ADVANCED_TEXT_MATERIAL = 'advanced-text-material',
    /** 功能列表 */
    FUNC_LIST = 'func-list',
    /** 矢量素材 */
    VECTOR_MATERIAL = 'vector-material',
    // 配方 14.1.0
    /** 文字变形素材 */
    TEXT_TRANSFORM = 'text-transform',
    // 跟随配方 15.0.0 定义，拼图的为app业务专属图层，不会出现在web，所以不需要实现
    /** 拼图网格素材 */
    PUZZLE_TEMPLATE = 'puzzle-template-material',
    /** 拼图海报素材 */
    PUZZLE_POSTER = 'puzzle-poster-material',
    /** 拼图拼接素材 */
    PUZZLE_JOINT = 'puzzle-joint-material',

    /** 放大镜素材 */
    MAGNIFIER = 'magnifier-material',

    /** 标记笔画笔素材 */
    ANNOTATION_PEN_BRUSH = 'annotation-pen-brush',

    /** 标记笔形状素材 */
    ANNOTATION_PEN_SHAPE = 'annotation-pen-shape',

    /** 标记笔线条素材 */
    ANNOTATION_PEN_LINE = 'annotation-pen-line',

    /** 标记笔箭头素材 */
    ANNOTATION_PEN_ARROW = 'annotation-pen-arrow',

    /** 文本纹理素材 */
    TEXT_TEXTURE = 'text-texture-material',
    /** 媒体素材 */
    MEDIA = 'media-material',
    /** 文本划重点素材 */
    TEXT_MARK = 'text-mark',

    /** 标记笔素材 */
    ANNOTATION_PEN_RULER = 'annotation-pen-ruler',
    /** MCP特效素材 */
    MCP_EFFECT = 'mcp-effect-material',

    /** 文字动画素材 */
    TEXT_ANIMATION = 'text-animation',

    /** 列表样式 */
    TEXT_LIST = 'text-list',
}

/** 图片图层功能标签 */
export enum ImgModeType {
    /** 无功能 */
    none = 0,
    /** 图片容器 */
    imgContainer = 1,
    /** 自动抠图 */
    matting = 2,
    /** 自动抠头 */
    mattingHead = 3,
}

/** 图片图层分类标签 */
export enum ImgCategoryType {
    /** 无标签 */
    none = 0,
    /** 素材 */
    material = 1,
    /** 背景 */
    bgImg = 2,
    /** 二维码 */
    qrCode = 3,
    /** 主图 */
    mainImg = 5,
    /** 辅图 */
    subImg = 6,

    /** 正面 */
    frontImg = 7,

    /** 背面 */
    backImg = 8,
}

/** 图层类型 */
export enum LayerType {
    /** 文字 */
    TEXT_LAYER = 'text',
    /** 图片 */
    IMAGE_LAYER = 'img',
    /** 组 */
    GROUP_LAYER = 'group',
    /** 背景 */
    BACKGROUND_LAYER = 'bg',
    /** 主图 */
    MAIN_LAYER = 'mainImg',
    /** 画笔 svg */
    SVG_LAYER = 'svg',
    /** 水印 */
    WATERMARK = 'watermark',
    /** 花字（新，载入后转成组操作） */
    ADVANCED_TEXT = 'advanced_text',
    /** 矢量素材 */
    VECTOR_LAYER = 'vector',
    /** 二维码 */
    QR_CODE = 'qr_code',
    /** 表格组件 */
    TABLE = 'table',
    /** 图表图层 */
    CHART = 'chart',
    /** 画笔 */
    BRUSH_LAYER = 'brush',
    /** 跟随配方 15.0.0 定义，拼图，app业务专属图层，不会出现在web，所以不需要实现 */
    PUZZLE = 'puzzle',
    /** 跟随配方 15.0.0 定义，拼图图片容器， app业务专属图层，不会出现在web，所以不需要实现 */
    PUZZLE_CONTAINER = 'puzzle_container',
    /** 放大镜图层 */
    MAGNIFIER = 'magnifier',
    /** 标注笔  */
    MARKUP_LAYER = 'markup',
    /** 媒体图层 */
    MEDIA_LAYER = 'media',
}

/** 舞台渲染模式 */
export enum StageType {
    /** 单画布模式 */
    SINGLE = 1,
    /** 多画布模式 */
    VARIETY = 2,
}

export enum PPTDemoMode {
    /** 演讲者模式 */
    SPEAKER = 'SPEAKER',
    /** 观众模式 */
    AUDIENCE = 'AUDIENCE',
}

/** 接口下发的模版模式 */
export enum CanvasType {
    /** 空画布 */
    NORMAL = 0,
    /** 单画布模式 */
    SINGLE = 1,
    /** 长图模式 */
    VARIETY = 2,
    /** 批量  */
    BATCH = 3,
    /** PPT 模式 */
    PPT = 4,
}

/** 海报类型 */
export enum PosterType {
    /** 普通海报 */
    Poster = 1,
    /** ai ppt  */
    AiPPT = 2,
    /** ai 海报  */
    AiPoster = 3,
    /** 团队模板 (后端接口中团队模板没有对应的poster_type, 应该是历史遗留问题, 所以之前的企业模板逻辑, 所以保留并随便给个数字, 这个值不会走到后端, 所以可以随意修改) */
    TeamTemplate = 99999,
    /** @deprecated 企业模板 */
    EnterpriseTemplate = 4,
    /** 空白海报 */
    EmptyPoster = 5,
    /** AI拼图(移动端占用) */
    AIPinTu = 6,
    /** 普通 PPT */
    NormalPPT = 7,
    /** 图片编辑 */
    ImageEditor = 10,
    /** AI 图片编辑编辑 */
    AIPhotoEditor = 16,
    /** 存量图片编辑历史记录 */
    ImageEditorHistory = 90,
    /** AI图文 */
    AIPostGen = 12,
}

/** 基础层类型 */
export enum BaseLayerViewType {
    /**
     * 图层类型
     */
    /** 普通渲染层 */
    LAYER = 'layer',
    /** 操作层 */
    OPERATE = 'operate',
    /** 操作遮罩层 */
    MASK = 'mask',
    /**
     * 操作类型
     */
    /** 锁定 */
    LOCK = 'lock',
    LOCK_ICON = 'lock-icon',
    /** 移动 */
    MOVE = 'move',
    /** 缩放 */
    SCALE = 'scale',
    /** 尺寸调整 */
    RESIZE = 'resize',
    /** 旋转 */
    ROTATE = 'rotate',
    /** 快捷操作 */
    SHORTCUT = 'shortcut',
    /** 组内移动 */
    LINK = 'link',
    LINK_ICON = 'link-icon',
    /** 文字编辑 */
    EDIT = 'edit',
    /** 擦肩舞台 */
    CROP_STAGE = 'crop-stage',
    /** 舞台尺寸调整 */
    STAGE_RESIZE = 'stage-resize',
    /** 参考线移动 */
    REFERENCE_LINE_MOVE = 'reference-line-move',

    /** 图层里面图片缩放 */
    IMAGE_SCALE = 'image-scale',
    /** 图层里面图片旋转 */
    IMAGE_ROTATE = 'image-rotate',
    /** 图层里面图片移动 */
    IMAGE_MOVE = 'image-move',

    /** 自定义 */
    CUSTOM = 'custom',
}

/** 缩放操作类型 */
export enum ScaleOperateType {
    /** 左上 */
    LT = 'lt',
    /** 左下 */
    LB = 'lb',
    /** 右上 */
    RT = 'rt',
    /** 右下 */
    RB = 'rb',
}

/** 尺寸操作类型 */
export enum ResizeOperateType {
    /** 上 */
    TC = 'tc',
    /** 下 */
    BC = 'bc',
    /** 左 */
    LC = 'lc',
    /** 右 */
    RC = 'rc',
}

/** 尺寸调整的操作类型 */
export enum ResizeActionType {
    /** 调整宽度 */
    RESIZE = 'resize',
    /** 调整缩放 */
    SCALE = 'scale',
}

export enum DirectionType {
    /** 正向 */
    POSITIVE = 1,
    /** 反向 */
    OPPOSITE = -1,
    /** 中心 */
    CENTER = 0,
}

/** 旋转操作类型 */
export enum RotateOperateType {
    /** 左上 */
    LT = 'lt',
    /** 右上 */
    RT = 'rt',
    /** 左下 */
    LB = 'lb',
    /** 右下 */
    RB = 'rb',
}

/** 对齐类型 */
export enum AlignType {
    /** 相对画布 */
    canvas = 'canvas',
    /** 元素之间 */
    group = 'group',
}
